module.exports = __webpack_public_path__ + "static/media/featureimage4.aca761a4.jpg";